import React from 'react';

const RatingBar = ({ percent, color }) => {
  return (
    <div className="progress progress-mini">
      <div
        style={{
          width: `${percent}%`,
          background: color,
        }}
        className="progress-bar"
      >
      </div>
      <span className="sr-only"> {`${percent}%`} </span>
    </div>
  );
};

export default RatingBar;
